export function splitFeatureTitle(title) {
  const text = String(title || '').trim();
  const match = text.match(/^(?:\[|【)(ID\d+)(?:\]|】)\s*(.*)$/i);
  if (!match) {
    return { issueId: '', text };
  }
  return {
    issueId: match[1].toUpperCase(),
    text: match[2].trim(),
  };
}

export function groupFeaturesByIssue(features) {
  const groups = [];
  const groupMap = new Map();

  for (const feature of features || []) {
    const { issueId, text } = splitFeatureTitle(feature.title);
    const key = issueId || `feature-${feature.id || groups.length}`;
    if (!groupMap.has(key)) {
      const group = { issueId, items: [] };
      groupMap.set(key, group);
      groups.push(group);
    }
    groupMap.get(key).items.push({ ...feature, text });
  }

  return groups;
}
